import Vue from 'vue'
import Vuex from 'vuex'
import { auth } from "./module/auth.module";
// import VuexPersistence from "vuex-persist";
import createPersistedState from "vuex-persistedstate";
import SecureLs from 'secure-ls'



Vue.use(Vuex)

const ls = new SecureLs({ encodingType: 'aes' })
const storageParams = {
  getItem: key => ls.get(key),
  setItem: (key, value) => ls.set(key, value),
  removeItem: key => ls.remove(key)
}

export default new Vuex.Store({
  plugins: [
    createPersistedState({
      key: 'vuex',
      storage: storageParams,
      reducer(state) {
        return {
          auth: state.auth,
          redirects: state.redirects,
        }
      }
    })
  ],
  state: {
    redirects: null
  },
  mutations: {
    setRedirect(state, redirects) {
      state.redirects = redirects
    }
  },
  modules: {
    auth
  }
})
